export default {"src":"/_next/static/image/public/images/ic_no_prescription.5be05bd93541485617f5584eafcb32fd.svg","height":176,"width":145};